import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n/I18nProvider";
import { AuthProvider, useAuth } from "@/hooks/useAuth";
import FunnelPage from "@/pages/Funnel/FunnelPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminReps from "@/pages/admin/AdminReps";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminConcerns from "@/pages/admin/AdminConcerns";
import AdminRoutines from "@/pages/admin/AdminRoutines";
import AdminCombos from "@/pages/admin/AdminCombos";
import AdminCollections from "@/pages/admin/AdminCollections";
import AdminForms from "@/pages/admin/AdminForms";
import AdminBanners from "@/pages/admin/AdminBanners";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";

function ProtectedAdmin({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bone">
        <p className="font-sans text-brand-muted text-sm">Loading…</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<FunnelPage />} />
            <Route path="/r/:repCode" element={<FunnelPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdmin>
                  <AdminLayout />
                </ProtectedAdmin>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="reps" element={<AdminReps />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="concerns" element={<AdminConcerns />} />
              <Route path="combos" element={<AdminCombos />} />
              <Route path="collections" element={<AdminCollections />} />
              <Route path="routines" element={<AdminRoutines />} />
              <Route path="forms" element={<AdminForms />} />
              <Route path="banners" element={<AdminBanners />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="analytics" element={<AdminAnalytics />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
